import type { ReactNode } from "react";
import { cn } from "@/shared/lib/cn";
import "./shopHero.css";

export interface ShopHeroRevealProps {
  /** `false` = movimiento reducido: se pinta directamente en su sitio. */
  animate: boolean;
  /** Milisegundos de retardo. Es lo que escalona la entrada. */
  delay?: number;
  className?: string;
  children: ReactNode;
}

/**
 * Envoltorio de aparición para los bloques que NO se parten en palabras:
 * el rótulo, la entradilla, el párrafo y el botón de bajar.
 *
 * ── El retardo es la única diferencia entre uno y otro ───────────────
 * De ahí la aparición escalonada: los bloques comparten animación y solo
 * cambia cuándo empieza cada uno. Escalonar es lo que hace que la portada
 * se lea en el orden en que está escrita en vez de aparecer de golpe.
 *
 * ── Con movimiento reducido no se pone NADA ──────────────────────────
 * Ni la clase ni el `animationDelay`. Es importante que el estado
 * escondido (`opacity: 0`) viva solo dentro de `.shop-hero-fade`: si
 * estuviera en una clase base, quitar la animación dejaría un texto
 * invisible para siempre, que es la peor forma posible de respetar una
 * preferencia de accesibilidad.
 */
export function ShopHeroReveal({
  animate,
  delay = 0,
  className,
  children,
}: ShopHeroRevealProps) {
  return (
    <div
      className={cn(animate && "shop-hero-fade", className)}
      style={animate ? { animationDelay: `${delay}ms` } : undefined}
    >
      {children}
    </div>
  );
}
